import { crossCuttingTaskState } from './types';

export function getCrossCuttingTasksMpk(state: crossCuttingTaskState) {
  return state.crossCuttingTask;
}
